export const formatErrorMessages = (errors) => {
  if (!errors || typeof errors !== 'object') {
    return '';
  }

  return Object.entries(errors)
    .map(([field, messages]) => {
      const capitalizedField = field.charAt(0).toUpperCase() + field.slice(1);
      const messageStr = Array.isArray(messages) ? messages.join(', ') : messages;
      return `${capitalizedField} ${messageStr}`;
    })
    .join('. ');
};
